// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99999;
  transition: opacity 0.3s ease;
}
.global-loader-container.active {
  pointer-events: auto;
}

/* --- Route Progress Bar --- */
.route-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  opacity: 0;
  transform: translateY(-4px);
  transition: opacity 0.3s, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100000;
}
.route-progress-bar.show {
  opacity: 1;
  transform: translateY(0);
}
.route-progress-bar .progress-line {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, var(--nav_bar_primary_color, maroon), var(--nav_bar_secondary_color, #c0392b), var(--nav_bar_primary_color, maroon));
  background-size: 200% 100%;
  animation: routeProgress 1.5s infinite linear;
}

@keyframes routeProgress {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/* --- API Overlay Loader --- */
.api-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  animation: fadeIn 0.3s ease-out;
}
.api-overlay .modern-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.api-overlay .spinner-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(var(--nav_bar_primary_color_rgb, 139, 0, 0), 0.1);
  border-top-color: var(--nav_bar_primary_color, maroon);
  border-radius: 50%;
  animation: spin 1s infinite cubic-bezier(0.5, 0.1, 0.4, 0.9);
}
.api-overlay .spinner-logo {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  padding: 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: pulse 1.5s infinite alternate ease-in-out;
}
.api-overlay .spinner-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.api-overlay .loading-text {
  font-size: 15px;
  font-weight: 700;
  color: var(--nav_bar_primary_color, maroon);
  letter-spacing: 1px;
  text-transform: uppercase;
  animation: textPulse 1.5s infinite alternate ease-in-out;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  from {
    transform: scale(1);
    opacity: 0.9;
  }
  to {
    transform: scale(1.1);
    opacity: 1;
  }
}
@keyframes textPulse {
  from {
    opacity: 0.5;
    transform: translateY(0);
  }
  to {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .api-overlay {
    background: rgba(255, 255, 255, 0.85);
    /* Slightly more opaque on mobile */
  }
  .api-overlay .modern-spinner {
    width: 70px;
    height: 70px;
  }
  .api-overlay .spinner-logo {
    width: 40px;
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,6BAAA;AACJ;AACI;EACI,oBAAA;AACR;;AAGA,+BAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,qEAAA;EACA,eAAA;AAAJ;AAEI;EACI,UAAA;EACA,wBAAA;AAAR;AAGI;EACI,WAAA;EACA,YAAA;EACA,uJAAA;EAIA,0BAAA;EACA,6CAAA;AAJR;;AAQA;EACI;IACI,2BAAA;EALN;EAQE;IACI,4BAAA;EANN;AACF;AASA,+BAAA;AACA;EACI,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,+BAAA;AAPJ;AASI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR;AAUI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;EACA,sDAAA;EACA,kBAAA;EACA,4DAAA;AARR;AAWI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,0CAAA;EACA,oDAAA;AATR;AAWQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AATZ;AAaI;EACI,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,wDAAA;AAXR;;AAeA;EACI;IACI,yBAAA;EAZN;AACF;AAeA;EACI;IACI,mBAAA;IACA,YAAA;EAbN;EAgBE;IACI,qBAAA;IACA,UAAA;EAdN;AACF;AAiBA;EACI;IACI,YAAA;IACA,wBAAA;EAfN;EAkBE;IACI,UAAA;IACA,2BAAA;EAhBN;AACF;AAmBA;EACI;IACI,UAAA;EAjBN;EAoBE;IACI,UAAA;EAlBN;AACF;AAqBA,2BAAA;AACA;EACI;IACI,qCAAA;IACA,mCAAA;EAnBN;EAqBM;IACI,WAAA;IACA,YAAA;EAnBV;EAsBM;IACI,WAAA;IACA,YAAA;EApBV;AACF","sourcesContent":[".global-loader-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 99999;\n    transition: opacity 0.3s ease;\n\n    &.active {\n        pointer-events: auto;\n    }\n}\n\n/* --- Route Progress Bar --- */\n.route-progress-bar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    background: rgba(255, 255, 255, 0.1);\n    overflow: hidden;\n    opacity: 0;\n    transform: translateY(-4px);\n    transition: opacity 0.3s, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    z-index: 100000;\n\n    &.show {\n        opacity: 1;\n        transform: translateY(0);\n    }\n\n    .progress-line {\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(90deg,\n                var(--nav_bar_primary_color, maroon),\n                var(--nav_bar_secondary_color, #c0392b),\n                var(--nav_bar_primary_color, maroon));\n        background-size: 200% 100%;\n        animation: routeProgress 1.5s infinite linear;\n    }\n}\n\n@keyframes routeProgress {\n    0% {\n        background-position: 200% 0;\n    }\n\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n/* --- API Overlay Loader --- */\n.api-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(4px);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    animation: fadeIn 0.3s ease-out;\n\n    .modern-spinner {\n        position: relative;\n        width: 80px;\n        height: 80px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .spinner-circle {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        border: 3px solid rgba(var(--nav_bar_primary_color_rgb, 139, 0, 0), 0.1);\n        border-top-color: var(--nav_bar_primary_color, maroon);\n        border-radius: 50%;\n        animation: spin 1s infinite cubic-bezier(0.5, 0.1, 0.4, 0.9);\n    }\n\n    .spinner-logo {\n        width: 45px;\n        height: 45px;\n        border-radius: 50%;\n        overflow: hidden;\n        background: #fff;\n        padding: 2px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n        animation: pulse 1.5s infinite alternate ease-in-out;\n\n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n        }\n    }\n\n    .loading-text {\n        font-size: 15px;\n        font-weight: 700;\n        color: var(--nav_bar_primary_color, maroon);\n        letter-spacing: 1px;\n        text-transform: uppercase;\n        animation: textPulse 1.5s infinite alternate ease-in-out;\n    }\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes pulse {\n    from {\n        transform: scale(1);\n        opacity: 0.9;\n    }\n\n    to {\n        transform: scale(1.1);\n        opacity: 1;\n    }\n}\n\n@keyframes textPulse {\n    from {\n        opacity: 0.5;\n        transform: translateY(0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(-2px);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .api-overlay {\n        background: rgba(255, 255, 255, 0.85);\n        /* Slightly more opaque on mobile */\n\n        .modern-spinner {\n            width: 70px;\n            height: 70px;\n        }\n\n        .spinner-logo {\n            width: 40px;\n            height: 40px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
